import { createRoute } from "@tanstack/react-router";
import { FpConsultantsMetricsChart } from "@/components/teams/fp-consultants-metrics-chart";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "Jarrod Polson",
    title: "FP Director",
    ownerId: "216df4eb-25b9-46a4-ab19-fa7b13bef0de",
    image: "/assets/headshots/jarrod-polson.png",
  },
  {
    name: "Jimmy Lacy",
    title: "FP Relational Channel Champion",
    ownerId: "caac2ac4-8a98-4c7e-bd62-25ab132cbd55",
    image: "/assets/headshots/jimmy-lacy.png",
  },
  {
    name: "Zach Starbeck",
    title: "FP Non Relational Channel Champion",
    ownerId: "4102fc39-e7b1-4e65-b3a5-9d94ea8bd1d3",
    image: "/assets/headshots/zach-starbeck.png",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/fp/consultants",
  component: () => (
    <TeamRosterPage team="FP Consultants" members={members}>
      <FpConsultantsMetricsChart />
    </TeamRosterPage>
  ),
});
